'use client';

import { getThemeColor } from '../get-theme-color/get-theme-color.mjs';
function getGradient(gradient, theme) {
  var merged = {
    from: (gradient === null || gradient === void 0 ? void 0 : gradient.from) || theme.defaultGradient.from,
    to: (gradient === null || gradient === void 0 ? void 0 : gradient.to) || theme.defaultGradient.to,
    deg: (gradient === null || gradient === void 0 ? void 0 : gradient.deg) || theme.defaultGradient.deg || 0
  };
  var fromColor = getThemeColor(merged.from, theme);
  var toColor = getThemeColor(merged.to, theme);
  return "linear-gradient(".concat(merged.deg, "deg, ").concat(fromColor, " 0%, ").concat(toColor, " 100%)");
}
export { getGradient };